module.exports = __webpack_public_path__ + "static/media/logo-comune-misterbianco.c2d40c26.jpg";